module.exports = __webpack_public_path__ + "static/img/96019A_1_R_20221026_LC.d2de8c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96019A_1_R_20221026_LC.png
// module id = QTiK
// module chunks = 0